var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08998 11.475C1.38248 11.7675 1.85498 11.7675 2.14748 11.475L3.99998 9.62254L5.85248 11.475C6.14498 11.7675 6.61748 11.7675 6.90998 11.475C7.20248 11.1825 7.20248 10.71 6.90998 10.4175L4.53248 8.04004C4.23998 7.74754 3.76748 7.74754 3.47498 8.04004L1.09748 10.4175C0.797481 10.7025 0.79748 11.1825 1.08998 11.475ZM6.90998 0.525039C6.61748 0.232539 6.14498 0.232539 5.85248 0.525039L3.99998 2.37754L2.14748 0.525039C1.85498 0.232539 1.38248 0.232539 1.08998 0.525039C0.79748 0.817539 0.79748 1.29754 1.08998 1.59004L3.46748 3.96754C3.75998 4.26004 4.23248 4.26004 4.52498 3.96754L6.90248 1.59004C7.20248 1.29754 7.20248 0.817539 6.90998 0.525039Z",
    fill: "#F4536E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLess);
export default __webpack_public_path__ + "static/media/ShowLess.4078e0d5.svg";
export { ForwardRef as ReactComponent };